// -----------------------------
// MegaMenuProducts Web Component
// -----------------------------
class MegaMenuProducts extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  updateProgressBar(swiper) {
    const progressBar = this.querySelector(
      'scroll-progress-bar .progress-bar'
    );
    if (!progressBar) return;

    const slidesPerView =
      typeof swiper.params.slidesPerView === 'number'
        ? swiper.params.slidesPerView
        : swiper.params.slidesPerView[swiper.currentBreakpoint];

    const totalSlides = swiper.slides.length;

    const totalSteps = Math.max(
      totalSlides - Math.ceil(slidesPerView) + 1,
      1
    );

    const currentStep = Math.min(swiper.realIndex + 1, totalSteps);
    const percentage = (currentStep / totalSteps) * 100;

    progressBar.style.width = `${percentage}%`;
  }

  initSwiper() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;

    const desktopItems = parseInt(
      swiperEl.getAttribute('desktop-item') || 4,
      10
    );

    const mobileItems = parseFloat(
      swiperEl.getAttribute('mobile-item') || 2.25
    );

    new Swiper(swiperEl, {
      slidesPerView: desktopItems,
      spaceBetween: 8,

      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        0: {
          slidesPerView: mobileItems, // ✅ 2.2 / 2.25 works
        },
        768: {
          slidesPerView: desktopItems,
        },
      },

      on: {
        init: (swiper) => this.updateProgressBar(swiper),
        slideChange: (swiper) => this.updateProgressBar(swiper),
        resize: (swiper) => this.updateProgressBar(swiper),
        breakpoint: (swiper) => this.updateProgressBar(swiper),
      },
    });
  }
}

// Define the Web Component
customElements.define('mega-menu-products', MegaMenuProducts);
